export interface Robot {
  name: string;
  season: string;
  imagePath?: string;
  url?: string;
}

export const robots: Robot[] = [
  {
    name: "L5xAH: BULLS-EYE",
    season: "2025: DOOMSDAY",
    imagePath: "/gallery/bullseye.jpg",
    url: "/rival/bulls-eye"
  },
  {
    name: "L5: Surge",
    season: "2025: DOOMSDAY",
    imagePath: "/gallery/surge.jpg",
    url: "/rival/surge"
  },
  {
    name: "L5xAH: IMPACT",
    season: "2024: KICKSTART",
    imagePath: "/gallery/impact.jpg",
    url: "/rival/impact"
  }
];